import clickElement from "./click-element";
import formInput from "./form-input";
import switchGroup from './switch-group';
import event from "../../lib/event";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

export default function createVar({id, name, type, isLocal, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    const strType = type == 'list' ? '列表' : '变量';
    if (mode) {
        if (!tips) tips = `创建一个名为（${name}）的${strType}，` + (isLocal ? '仅适用于当前角色' : '适用于所有角色');
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }

    return switchGroup({
        id: 'variables',
        tips: '点击切换到『变量』积木组'
    }).then(()=>clickElement({
        element: "建立一个" + strType,
        tips: "点击这里创建一个新" + strType
    })).then(()=>formInput({
        element: 'input[class^="prompt_variable-name-text-input"]',
        value: name,
        tips: `这里输入${strType}名『${name}』`
    })).then(()=>{
        if (isLocal) {
            return clickElement({
                element: 'input[name="variableScopeOption"][value="local"]',
                tips: '点击这个选项，限制' + strType + '的作用域只适用于当前角色'
            })
        }
    }).then(()=>{
        event.once('var_create', e=>{
            stepsRuntime.setBlockId(e.varId, id);
        });
    }).then(()=>clickElement({
        element: 'button[class^="prompt_ok-button"]',
        tips: '点击『确定』完成创建'
    })).then(()=>new Promise(resolve => {
        setTimeout(()=>{resolve()}, 500);
    }));

}
